
import { Component, ElementRef, HostBinding, Inject, OnDestroy, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { FuseConfigService } from '../../@fuse/services/config.service';
import { Subscription } from 'rxjs';
import { EventService } from '../services/event.service';
import { AutoLogoutWarningMsgBoxComponent } from '../shared/components/autoLogoutWarningMsgBox/autoLogoutWarningMsgBox.component';
import { CloseTillComponent } from '../shared/components/close-till/close-till.component';

@Component({
    selector: 'fuse-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FuseMainComponent implements OnDestroy {
    onConfigChanged: Subscription;
    fuseSettings: any;
    @HostBinding('attr.fuse-layout-mode') layoutMode;

    @ViewChild(AutoLogoutWarningMsgBoxComponent) dlgAutoLogout: AutoLogoutWarningMsgBoxComponent;
    @ViewChild(CloseTillComponent) dlgCloseTill: CloseTillComponent;

    public ShowToolbar: boolean = false;
    public ShowNavMenu: boolean = false;

    subAutoLogoutTriggered: Subscription;
    subShowAutoLogoutWarningDlg: Subscription;
    SystemCommandSub: Subscription;

    constructor(
        private _renderer: Renderer2,
        private _elementRef: ElementRef,
        private fuseConfig: FuseConfigService,
        private events: EventService,
    ) {
        this.onConfigChanged = this.fuseConfig.onConfigChanged.subscribe(
            (newSettings) => {
                this.fuseSettings = newSettings;
                this.layoutMode = this.fuseSettings.layout.mode;
            },
        );

        this.SystemCommandSub = this.events.onSystemCommand.subscribe(r => {
            if (r) {
                if (r.command == "CloseTill") {
                    this.dlgCloseTill.show();
                }
            }
        });

        // Turn Top toolbar and Left Nav off
        this.ShowToolbar = false;
        this.ShowNavMenu = false;

        this.events.onSessionContextChanged.subscribe(s => {
            this.ShowToolbar = false;
            this.ShowNavMenu = false;
            if (s) {
                if (s.EmployeeId) {
                    // Turn Top toolbar and Left Nav on if we have employee in session
                    this.ShowToolbar = (s.EmployeeId > 0);
                    this.ShowNavMenu = (s.EmployeeId > 0);
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.onConfigChanged) this.onConfigChanged.unsubscribe();
        if (this.subAutoLogoutTriggered) this.subAutoLogoutTriggered.unsubscribe();
        if (this.subShowAutoLogoutWarningDlg) this.subShowAutoLogoutWarningDlg.unsubscribe();
        if (this.SystemCommandSub) this.SystemCommandSub.unsubscribe();
    }

    addClass(className: string) {
        this._renderer.addClass(this._elementRef.nativeElement, className);
    }

    removeClass(className: string) {
        this._renderer.removeClass(this._elementRef.nativeElement, className);
    }
}
